// extracted by mini-css-extract-plugin
export default {"crosswordModal":"SlidingPuzzleModal_crosswordModal__UmgmC","body":"SlidingPuzzleModal_body__wrKz5"};